// BOOTSTRAP 5 JS
import 'bootstrap/dist/js/bootstrap.esm.js'

// CUSTOM JS
import './nav_bs5'
import './stripe_styling.js' // checkout credit card form styling
import '../../shared/phone.js' // sets phone number based on locale
import '../../f1/horizontal_scroll' // image slider
import '../../shared/buyers_page_personalizer.js' // buyers page
import '../../shared/package_comparisons.js' // package comparison feature
import '../../shared/hide_map.js' // show/hide map on mobile seating chart
import '../../shared/disable_reset.js' // reset filters button functionality
import '../../default/carousel_bs5.js' // popout lightbox modal
import './seating_chart_filter.js' // js for PriceFilter
import './light_dark_mode.js'

// BASE VUE
import VueLoader from '../../default/vue-loader.js'
import { store } from '../../default/store/index.js'

// VUE COMPONENTS
import PriceFilter from '../../shared/price_filter' // seating chart price and range slider component
import AddToCart from '../../full-gpe/cart/add-to-cart.js' // package page bottom form
import AddToCartForms from '../../shared/add_to_cart_forms/index.js' // loads appropriate package page bottom form
import HotelIndex from '../../shared/add_to_cart_forms/h4h_hotels/hotel_index.vue' // h4h hotel index
import CartNav from '../../shared/nav/nav_cart/index.js' // loads nav cart
import Checkout from '../../shared/checkout/index.js' // loads checkout
import AbTests from '../../shared/ab_tests.js' // loads ab tests
import DepositRedemptions from '../../shared/deposit_redemptions/index.js' // loads deposit redemptions

// VARIABLES
const contracted_hotel = document.getElementById('h4hHotelIndex')
const retail_hotel = document.getElementById('hotelPage')

// LOAD
document.addEventListener('turbo:load', () => {
  AddToCartForms.loadBottomForm()
  CartNav.addCartToNavbar()
  DepositRedemptions.findCustomerDeposits()
  Checkout.loadWithAddOn()
  AddToCart.AddToCart()

  if (contracted_hotel || retail_hotel) {
    AbTests.loadHotelAbTests() // should this only be loaded on hotel pages? #hotelPage (/hotel/34373 retail hotel) #h4hHotelIndex (checkout hotel path for both index AND show pages)
  }

  if (document.getElementById('seating_chart_price')) {
    VueLoader.loadVueComponent(PriceFilter, document.getElementById('seating_chart_price'), store)
  }

  if (document.getElementById('hotelIndex')) {
    VueLoader.loadVueComponent(HotelIndex, document.getElementById('hotelIndex'), store)
  }
})

// currently unused
import '../tooltip'
// import './ticket_seating_chart'
// import PricingFilterButtons from './pricing_filter/pricing_filter_buttons'
// import '../shared/nav/collapsing_md_nav.js'
// import './platinium'
// import './top_nav'
// import './mobile_partner_nav'
// import './nav.js'
// import './video'

// currently unneeded?
// import '../shared/h4h_form.js' LOADS OLD H4H BOTTOM FORM
// import '../shared/phone.js' sets phone number based on locale... do we need this?
// import PackageTabs from '../shared/package_tabs.js' tabbed functionality (like tabs in admin site) possibly not needed
// PackageTabs.loadTabs(782)